import { useEffect } from "react";
import $ from "jquery";
import { Link, useOutletContext } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getThemeColor } from "../../utils/constants";

export default function Footer({ store, theme }) {
  useEffect(() => {
    $(".footer-links .h4").on("click", function () {
      if ($(window).width() < 767) {
        $(this).next().slideToggle();
        $(this).addClass("active");
      }
    });
  }, []);

  const { slug } = useParams();

  return (
    <>
      <div className="footer footer-1">
        <div className="footer-top clearfix">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 text-center about-col mb-4">
                <p>{store?.address}</p>
                <p className="mb-0 mb-md-3">
                  <b>Phone:</b>{" "}
                  <a href="tel:+011234567890">{store?.phoneNumber}</a>
                  <span className="mx-1">|</span> <b>Email:</b>{" "}
                  <a href="mailto:info@example.com">{store?.emailAddress}</a>
                </p>
                <p className="mx-auto max-w-40rem my-4">{store?.description}</p>
                <a
                  href={`${process.env.REACT_APP_BILLSCLAN_URL}/signup?referrer_username=${store?.userName}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    borderColor: getThemeColor(theme).backgroundColor,
                  }}
                  class="d-inline-flex align-items-center btn btn-outline-primary rounded me-2 mb-2 me-sm-3">
                  GET YOUR OWN ONLINE STORE
                  <i
                    class="ms-2 icon an an-angle-right-r"
                    style={{
                      color: getThemeColor(theme).backgroundColor,
                    }}></i>
                </a>
              </div>
            </div>
            <div className="row d-flex">
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 footer-links">
                <h4 className="h4">Information</h4>
                <ul>
                  <li>
                    <a href={`${process.env.REACT_APP_BILLSCLAN_URL}/shop`}>
                      About us
                    </a>
                  </li>

                  <li>
                    <a
                      href={`${process.env.REACT_APP_BILLSCLAN_URL}/privacy`}
                      rel="noopener noreferrer"
                      target="_blank">
                      Privacy policy
                    </a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.REACT_APP_BILLSCLAN_URL}/terms`}
                      rel="noopener noreferrer"
                      target="_blank">
                      Terms &amp; condition
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 footer-links">
                <h4 className="h4">Quick Shop</h4>
                <ul>
                  {store?.categories.map((category) => (
                    <li>
                      <Link to={`/${slug}?category=${category.categoryId}`}>
                        {category.categoryName}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="col-12 col-sm-12 col-md-4 col-lg-4 footer-links">
                <h4 className="h4">Customer Services</h4>
                <ul>
                  <li>
                    <a
                      href={`${process.env.REACT_APP_BILLSCLAN_URL}/FAQ`}
                      rel="noopener noreferrer"
                      target="_blank">
                      FAQ's
                    </a>
                  </li>
                  <li>
                    <a href="mailto:hello@billsclan.com">Contact Us</a>
                  </li>
                  <li>
                    <a
                      href={`${process.env.REACT_APP_BILLSCLAN_URL}/terms`}
                      rel="noopener noreferrer"
                      target="_blank">
                      Orders and Returns
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.billsclan.com/Support"
                      rel="noopener noreferrer"
                      target="_blank">
                      Support Center
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom clearfix">
          <div className="container">
            <div className="d-flex-center flex-column justify-content-md-between flex-md-row-reverse">
              <img
                src={require("../../assets/images/payment.png")}
                alt="Paypal Visa Payments"
              />
              <div className="copytext text-uppercase">
                &copy; {new Date().getFullYear()} Billsclan. All Rights
                Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
      <span id="site-scroll">
        <i className="icon an an-chevron-up"></i>
      </span>
    </>
  );
}
